/* InteractiveViewer组件样式 */
.threejs-viewer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--background-color);
  border: none;
  border-radius: 0;
  box-shadow: none;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 确保不受浏览器缩放影响 */
  max-width: 100vw;
  max-height: 100vh;
  /* 使用transform来保持布局稳定性 */
  transform: translateZ(0);
  /* 确保在所有缩放比例下都能正常显示 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.threejs-viewer.fullscreen {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border-radius: 0;
}

.viewer-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  background: linear-gradient(135deg, var(--accent-color), #5a67d8);
  color: white;
  border-bottom: 1px solid var(--border-color);
  position: relative;
}

.viewer-header h3 {
  margin: 0;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  left: 20px;
}

.viewer-controls {
  display: flex;
  gap: 8px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.control-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.control-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.control-btn.close-btn {
  background: rgba(239, 68, 68, 0.8);
  border-color: rgba(239, 68, 68, 0.4);
}

.control-btn.close-btn:hover {
  background: rgba(239, 68, 68, 1);
}

.viewer-content {
  flex: 1;
  display: flex;
  position: relative;
  background: #f8f9fa;
}

.html-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
  /* 确保iframe在不同缩放比例下保持正确显示 */
  display: block;
  overflow: hidden;
}

.no-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.no-content i {
  font-size: 3rem;
  margin-bottom: 15px;
  opacity: 0.5;
}

.viewer-info {
  padding: 10px 20px;
  background: var(--background-secondary);
  border-top: 1px solid var(--border-color);
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.viewer-info p {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.viewer-info i {
  color: var(--accent-color);
}

/* 移动端响应式优化 */
@media (max-width: 768px) {
  .threejs-viewer {
    /* 保持全屏显示，不改变尺寸 */
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  
  .viewer-header {
    padding: 12px 15px;
  }
  
  .viewer-header h3 {
    font-size: 1.1rem;
  }
  
  .viewer-controls {
    gap: 5px;
  }
  
  .control-btn {
    padding: 6px 10px;
    font-size: 0.85rem;
  }
  
  .control-btn span {
    display: none; /* 小屏幕上只显示图标 */
  }
  
  .viewer-info {
    padding: 8px 15px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .threejs-viewer {
    /* 保持全屏显示，不改变尺寸 */
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  
  .viewer-header {
    padding: 10px;
  }
  
  .viewer-header h3 {
    font-size: 1rem;
  }
  
  .control-btn {
    padding: 5px 8px;
    min-width: 32px;
    justify-content: center;
  }
  
  .no-content {
    font-size: 1rem;
    padding: 0 15px;
    text-align: center;
  }
  
  .no-content i {
    font-size: 2.5rem;
    margin-bottom: 10px;
  }
} 